import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBolt,
  faGaugeHigh,
  faMicrochip,
  faShieldHalved,
  faScrewdriverWrench,
  faStar,
  faTags
} from '@fortawesome/free-solid-svg-icons';

const reasons = [
  { title: 'Checked before sale', copy: 'Every PC is inspected so you can buy with confidence.', icon: faShieldHalved },
  { title: 'Performance advice', copy: 'Tell us what you play and we will help match the machine.', icon: faGaugeHigh },
  { title: 'Upgrade friendly', copy: 'Ask about components, storage, graphics cards and future boosts.', icon: faScrewdriverWrench }
];

const pcs = [
  { image: '/images/2026/updated/gameonpc1.jpeg', title: 'Sneaker X Gaming PC', price: 'GBP 1699.99' },
  { image: '/images/2026/updated/gameonpc2.jpeg', title: 'Ryzen 9 Gaming PC', price: 'GBP 1199.99' },
  { image: '/images/2026/updated/gameonpc3.jpeg', title: 'RTX 5070 Gaming PC', price: 'GBP 1699.99' },
  { image: '/images/2026/updated/gameonpc4.jpeg', title: 'Radeon Gaming PC', price: 'GBP 1099.99' }
];

const PCBuilding = () => (
  <div className="content-page pc-2026">
    <section className="about-cinematic-hero pc-cinematic-hero">
      <img className="about-hero-background" src="/images/2026/pc-building/pc-building-hero.webp" alt="Pixel art gaming PC build and testing workshop" fetchPriority="high" />
      <div className="about-hero-content">
        <p className="pixel-kicker">Performance unlocked</p>
        <p className="eyebrow">Game On PC Building</p>
        <h1>Built to play. Tested to win.</h1>
        <p>
          Gaming PCs matched to what you play, checked before sale and supported by practical local upgrade advice.
        </p>
        <div className="hero-actions">
          <Link className="pixel-button" to="/contact">Ask about a build</Link>
          <a className="btn-ghost" href="https://www.ebay.co.uk/str/gameoncoham" target="_blank" rel="noopener noreferrer">View available PCs</a>
        </div>
      </div>
      <div className="about-hero-proof" aria-label="Game On PC building highlights">
        <div><strong>Built & tested</strong><span>Checked before sale</span></div>
        <div><strong>Matched to you</strong><span>Performance for your games</span></div>
        <div><strong>Upgrade ready</strong><span>Advice beyond checkout</span></div>
      </div>
    </section>

    <section className="radar-section">
      <div className="radar-section-heading">
        <p className="eyebrow">Why Game On PCs</p>
        <h2>High-spec machines without the mystery.</h2>
      </div>
      <div className="category-grid">
        {reasons.map((reason) => (
          <article className="category-card" key={reason.title}>
            <FontAwesomeIcon icon={reason.icon} />
            <h3>{reason.title}</h3>
            <p>{reason.copy}</p>
          </article>
        ))}
      </div>
    </section>

    <section className="radar-section">
      <div className="radar-section-heading">
        <p className="eyebrow">Featured PCs</p>
        <h2>Built, checked and ready for serious sessions.</h2>
        <Link to="/contact">Ask availability</Link>
      </div>
      <div className="pc-editorial-grid">
        {pcs.map((pc) => (
          <article className="pc-editorial-card pc-poster-card" key={pc.title}>
            <img src={pc.image} alt={`${pc.title} at Game On Cosham`} loading="lazy" decoding="async" />
            <div>
              <p><FontAwesomeIcon icon={faStar} /> Featured build</p>
              <h3>{pc.title}</h3>
              <strong>{pc.price}</strong>
            </div>
          </article>
        ))}
      </div>
    </section>

    <section className="visit-callout">
      <div>
        <p className="eyebrow">Upgrade path</p>
        <h2>Need more frames, storage or a full new rig?</h2>
        <p>
          <FontAwesomeIcon icon={faMicrochip} /> Components
          <FontAwesomeIcon icon={faBolt} /> Performance
          <FontAwesomeIcon icon={faTags} /> Value
        </p>
      </div>
      <Link className="btn-red" to="/contact">Talk to us</Link>
    </section>
  </div>
);

export default PCBuilding;
